module.exports = __webpack_public_path__ + "custom-config/img/vip-dialog-icon.e140e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/tv/assets/img/vip-dialog-icon.png
// module id = Aee5
// module chunks = 2 3 4 6 7 8 9